import { Typography, Avatar, Button } from "@mui/material";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";

const EmailButton = ({
  shareLink,
  rawText,
  title,
  insightSummary,
  organizationName,
}: {
  shareLink: string;
  rawText: string;
  title: string;
  insightSummary?: string;
  organizationName: string;
}) => {
  const openEmail = () => {
    const body = [
      insightSummary || "<<Your Text Here>>",
      "Add some context on this clip for your recipient.",
      `Check out this Cloverleaf AI clip. ${encodeURIComponent(shareLink)}`,
      `Government Agency: ${organizationName}`,
      `Meeting Name: ${title}`,
      `Clip Text: "${rawText}"`,
      "Best Regards,",
    ].join("%0D%0D");

    window.open(`mailto:?subject=<<Your Text Here>>&body=${body}`);
  };

  return (
    <Button
      className="flex flex-col items-center rounded-xl"
      onClick={openEmail}
    >
      <Avatar
        aria-label="email"
        variant="circular"
        sx={{ backgroundColor: "#888888", height: "60px", width: "60px" }}
      >
        <EmailRoundedIcon fontSize="large" />
      </Avatar>
      <Typography variant="h6">Email</Typography>
    </Button>
  );
};

export default EmailButton;
